/* eslint-disable @typescript-eslint/no-unused-vars */
export const defaultFormatters = {
    yearFormat: "%Y",
    quarterFormat: "%b",
    monthFormat: "%b",
    weekFormat: "%e",
    dayFormat: "%e",
    hourFormat: "%H:%M",
    minuteFormat: "%H:%M",
    secondFormat: "%H:%M:%S",
    milliSecondFormat: ".%L",
};
export const levelDefinition = [
    /* 22 */ (d, date, i) => d.startOfYear && date.getFullYear() % 12 === 0 && "yearFormat",
    /* 21 */ (d, date, i) => d.startOfYear && date.getFullYear() % 4 === 0 && "yearFormat",
    /* 20 */ (d, date, i) => d.startOfYear && date.getFullYear() % 2 === 0 && "yearFormat",
    /* 19 */ (d, date, i) => d.startOfYear && "yearFormat",
    /* 18 */ (d, date, i) => d.startOfQuarter && "quarterFormat",
    /* 17 */ (d, date, i) => d.startOfMonth && "monthFormat",
    /* 16 */ (d, date, i) => d.startOfWeek && "weekFormat",
    /* 15 */ (d, date, i) => d.startOfDay && i % 2 === 0 && "dayFormat",
    /* 14 */ (d, date, i) => d.startOfDay && "dayFormat",
    /* 13 */ (d, date, i) => d.startOfHalfDay && "hourFormat",
    /* 12 */ (d, date, i) => d.startOfQuarterDay && "hourFormat",
    /* 11 */ (d, date, i) => d.startOfEighthOfADay && "hourFormat",
    /* 10 */ (d, date, i) => d.startOfHour && date.getHours() % 2 === 0 && "hourFormat",
    /* 9  */ (d, date, i) => d.startOfHour && "hourFormat",
    /* 8  */ (d, date, i) => d.startOf30Minutes && "minuteFormat",
    /* 7  */ (d, date, i) => d.startOf15Minutes && "minuteFormat",
    /* 6  */ (d, date, i) => d.startOf5Minutes && "minuteFormat",
    /* 5  */ (d, date, i) => d.startOfMinute && "minuteFormat",
    /* 4  */ (d, date, i) => d.startOf30Seconds && "secondFormat",
    /* 3  */ (d, date, i) => d.startOf15Seconds && "secondFormat",
    /* 2  */ (d, date, i) => d.startOf5Seconds && "secondFormat",
    /* 1  */ (d, date, i) => d.startOfSecond && "secondFormat",
    /* 0  */ (d, date, i) => "milliSecondFormat",
];
//# sourceMappingURL=levels.js.map